var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M19.213 2.491l.156 3.233a9.656 9.656 0 00-7.376-3.412c-4.73 0-8.668 3.396-9.513 7.884a.473.473 0 00.1.385c.09.107.222.169.361.169h1.916a.47.47 0 00.456-.362 6.87 6.87 0 0112.383-2.223l-3.964-.19a.467.467 0 00-.491.468v1.852c0 .259.21.469.47.469h7.82c.26 0 .469-.21.469-.47V2.47c0-.26-.21-.469-.469-.469h-1.85a.476.476 0 00-.34.145.471.471 0 00-.128.346zm-7.22 16.384a6.858 6.858 0 01-5.703-3.04l3.977.191a.468.468 0 00.491-.469v-1.851a.469.469 0 00-.469-.469H2.47c-.26 0-.469.21-.469.469v7.825c0 .26.21.469.469.469h1.85c.128 0 .25-.052.34-.145a.47.47 0 00.128-.347l-.162-3.226a9.652 9.652 0 007.368 3.405c4.731 0 8.67-3.395 9.514-7.883a.473.473 0 00-.1-.385.472.472 0 00-.36-.169H19.13a.47.47 0 00-.456.362 6.868 6.868 0 01-6.68 5.263z"
  }))));
}

export default SvgSync;